import { createRouter, createWebHistory } from "vue-router";
import { ReviseMeta } from "@/util/meta";
import { homeMeta, preMeta, downMeta, crossoverMeta } from "./metaI18n";
import { deviceType, lang } from "@/util/base";
import { xhGet } from "@/util/xhCookie";

function createAdRoutes(platforms) {
  return platforms.flatMap(({ prefix, versions, componentMap }) =>
    versions.map((version) => ({
      path: `${prefix}-${version}`,
      name: `${prefix}-${version}`,
      component: () =>
        import(`./views/down/${componentMap[version] || version}.vue`),
    }))
  );
}

const adRoutesVersions = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

// 特殊映射

const adRoutes = createAdRoutes([
  {
    prefix: "TT", // 抖音
    versions: adRoutesVersions,
    componentMap: "",
  },
  {
    prefix: "FB", // 脸书
    versions: adRoutesVersions,
    componentMap: "",
  },
  {
    prefix: "GG", // 谷歌
    versions: adRoutesVersions,
    componentMap: "",
  },
  {
    prefix: "line", // line
    versions: adRoutesVersions,
    componentMap: "",
  },
]);

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 入口页面
    {
      path: "/",
      component: () => import("./views/gw/index.vue"),
      meta: homeMeta[xhGet("XH-WEB")?.page_lang || lang()] || homeMeta.en,
    },
    // 东南亚预约 PC端
    {
      path: "/pre",
      component: () => import("./views/gw/index.vue"),
      meta: preMeta[xhGet("XH-WEB")?.page_lang || lang()] || preMeta.en,
    },
    // 东南亚预约 wap端
    {
      path: "/pre/m",
      component: () => import("./views/gw/index.vue"),
      meta: preMeta[xhGet("XH-WEB")?.page_lang || lang()] || preMeta.en,
    },
    // 营销广告投放页
    {
      path: "/pre/GG",
      component: () => import("./views/yy/index.vue"),
      meta: preMeta[xhGet("XH-WEB")?.page_lang || lang()] || preMeta.en,
    },
    {
      path: "/pre/TT",
      component: () => import("./views/yy/index.vue"),
      meta: preMeta[xhGet("XH-WEB")?.page_lang || lang()] || preMeta.en,
    },
    {
      path: "/pre/FB",
      component: () => import("./views/yy/index.vue"),
      meta: preMeta[xhGet("XH-WEB")?.page_lang || lang()] || preMeta.en,
    },
    {
      path: "/pre/line",
      component: () => import("./views/yy/index.vue"),
      meta: preMeta[xhGet("XH-WEB")?.page_lang || lang()] || preMeta.en,
    },
    // 官网
    {
      path: "/home",
      component: () => import("./views/gw/index.vue"),
      meta: homeMeta[xhGet("XH-WEB")?.page_lang || lang()] || homeMeta.en,
    },
    {
      path: "/home/m",
      component: () => import("./views/gw/index.vue"),
      meta: homeMeta[xhGet("XH-WEB")?.page_lang || lang()] || homeMeta.en,
    },
    // 官网新闻
    {
      path: "/news",
      component: () => import("./views/gw/news.vue"),
      meta: homeMeta[xhGet("XH-WEB")?.page_lang || lang()] || homeMeta.en,
    },
    {
      path: "/news/m",
      component: () => import("./views/gw/news.vue"),
      meta: homeMeta[xhGet("XH-WEB")?.page_lang || lang()] || homeMeta.en,
    },
    // 官网内容
    {
      path: "/content",
      component: () => import("./views/gw/content.vue"),
      meta: homeMeta[xhGet("XH-WEB")?.page_lang || lang()] || homeMeta.en,
    },
    {
      path: "/content/m",
      component: () => import("./views/gw/content.vue"),
      meta: homeMeta[xhGet("XH-WEB")?.page_lang || lang()] || homeMeta.en,
    },
    // 协议
    // 东南亚
    {
      path: "/protocol",
      component: () => import("./views/protocol.vue"),
    },
    // 欧美
    {
      path: "/protocol-na",
      component: () => import("./views/na-protocol.vue"),
    },
    // 下载
    {
      path: "/down",
      meta: downMeta[xhGet("XH-WEB")?.page_lang || lang()] || downMeta.en,
      children: adRoutes,
    },
    // 联动活动
    {
      path: "/crossover",
      component: () => import("./views/crossover/index.vue"),
      meta:
        crossoverMeta[xhGet("XH-WEB")?.page_lang || lang()] || crossoverMeta.en,
    },
    // 404
    {
      path: "/:pathMatch(.*)*",
      component: () => import("../../components/404.vue"),
    },
    {
      path: "/test",
      component: () => import("./views/test.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  // 路由发生变化改变description和keyword
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description);
  // 只在特定路由路径下执行刷新
  if (to.name === "yymen") {
    // location.reload();
  }

  // 根据PC或者移动端跳转
  if (deviceType() == "wap") {
    if (to.path == "/pre") {
      next({ path: "/pre/m", query: to.query });
    } else if (to.path == "/us/pre") {
      next({ path: "/us/pre/m", query: to.query });
    } else {
      next();
    }
  } else {
    if (to.path == "/pre/m") {
      next({ path: "/pre", query: to.query });
    } else if (to.path == "/us/pre/m") {
      next({ path: "/us/pre", query: to.query });
    } else {
      next();
    }
  }
  next();
});

export default router;
